export default "/images/vendor/flag-icon-css/flags/4x3/nr.svg?dcf2ea3a8e5dbf8a9b805ecb2d2fc922";